<div class="flex flex-column align-items-center" data-test-id="errorBaseComponent.container">
  <h1 class="m-0 text-center title" data-test-id="errorBaseComponent.title">{{ pageTitle() }}</h1>
  <h2 class="m-0 text-center description" data-test-id="errorBaseComponent.description">{{ pageDescription() }}</h2>
</div>
